import React, { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images = [], index, onClose, onIndex }) {
  const total = images.length;
  const prev = useCallback(() => onIndex((index - 1 + total) % total), [index, total, onIndex]);
  const next = useCallback(() => onIndex((index + 1) % total), [index, total, onIndex]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [prev, next, onClose]);

  if (index == null || !total) return null;

  return (
    <div
      data-testid="lightbox"
      className="fixed inset-0 bg-black/90 flex items-center justify-center"
      style={{ zIndex: 2147483647 }}
      onClick={onClose}
    >
      <button
        data-testid="lightbox-close"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-5 right-5 text-white/80 hover:text-white transition-colors"
        aria-label="Close"
      >
        <X size={28} strokeWidth={1.5} />
      </button>

      {total > 1 && (
        <>
          <button
            data-testid="lightbox-prev"
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft size={40} strokeWidth={1.5} />
          </button>
          <button
            data-testid="lightbox-next"
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors"
            aria-label="Next"
          >
            <ChevronRight size={40} strokeWidth={1.5} />
          </button>
        </>
      )}

      <img
        data-testid="lightbox-image"
        src={images[index]}
        alt=""
        onClick={(e) => e.stopPropagation()}
        className="max-h-[86vh] max-w-[92vw] object-contain shadow-2xl"
      />

      {total > 1 && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-sm font-medium tracking-wider">
          {index + 1} / {total}
        </div>
      )}
    </div>
  );
}
